<button mat-icon-button [matMenuTriggerFor]="messagesMenu" (click)="openMessagesMenu()" #messagesMenuTrigger="matMenuTrigger">
    <mat-icon *ngIf="messages.length > 0" matBadge="{{messages.length}}" matBadgeColor="warn">notifications</mat-icon>
    <mat-icon *ngIf="messages.length <= 0">notifications</mat-icon>
</button>
<mat-menu #messagesMenu="matMenu" [overlapTrigger]="false" class="toolbar-dropdown-menu messages">
    <span (mouseleave)="messagesMenuTrigger.closeMenu()">
        <mat-tab-group backgroundColor="primary" (click)="stopClickPropagate($event)" [selectedIndex]="selectedTab">
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon>message</mat-icon>
                </ng-template>
                <mat-card class="content" [perfectScrollbar]="">
                  <div fxLayout="column" fxLayoutAlign="none" *ngFor="let message of messages">
                        <button mat-button *ngIf="message.key == 'lodger'" routerLink="/compte-utilisateur/message/proprietaire"> 
                            <img *ngIf="message.user_image != null" src="{{hostService.getHttpsImage()+message.user_image}}" width="50" alt="{{message.user_name}}"> 
                            <img *ngIf="message.user_image == null" src="assets/images/profile/julia.jpg" width="50">
                            <div fxLayout="column" fxLayoutAlign="none" class="w-100">
                                <div fxLayout="row" fxLayoutAlign="space-between start">
                                    <span class="name">{{message.user_name}} </span>
                                    <span class="info"><mat-icon>access_time</mat-icon> {{message.created_at | date:'short'}}</span>
                                </div>
                                <span class="text text-muted">{{message.message_text}}</span>
                            </div>
                        </button>
                        <button mat-button *ngIf="message.key == 'owner'" routerLink="/compte-utilisateur/message/locataire"> 
                            <img *ngIf="message.user_image != null" src="{{hostService.getHttpsImage()+message.user_image}}" width="50" alt="{{message.user_name}}"> 
                            <img *ngIf="message.user_image == null" src="assets/images/profile/julia.jpg" width="50">
                            <div fxLayout="column" fxLayoutAlign="none" class="w-100">
                                <div fxLayout="row" fxLayoutAlign="space-between start">
                                    <span class="name">{{message.user_name}} </span>
                                    <span class="info"><mat-icon>access_time</mat-icon> {{message.created_at | date:'short'}}</span>
                                </div>
                                <span class="text text-muted">{{message.message_text}}</span>
                            </div>
                        </button>
                    </div>             
                </mat-card>
            </mat-tab>
            <mat-tab>
            </mat-tab>
            <mat-tab>
            </mat-tab>
        </mat-tab-group>
    </span>
</mat-menu>